import Button from "@/components/buttons/Button";
import { Link } from "react-router-dom";

import BG from "@/assets/images/Rectangle.svg";

const TopBanner = () => {

    return (
        <div
        style={{
            backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)), url(${BG})`,
            backgroundSize: 'cover',
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            backgroundBlendMode: "overlay",
            boxShadow: `
                12px 0px 24px 2px rgba(162, 153, 141, 0.05), 
                0px 12px 24px 2px rgba(162, 153, 141, 0.05)
            `,
        }}
        

            className="bg-white shadow-sm rounded-lg p-6 mt-5">
            <h2 className="text-xl font-bold text-orange-500 mb-2">
                Invest in Zanzibar's Thriving Tourism Sector
            </h2>
            <p className="text-[#3C1E03] text-sm mb-4 font-light">
                Whether you're starting a new venture or expanding your business, our streamlined licensing and investment process ensures your success in one of the Africa's top destinations.
            </p>
            <Link to={"/applications/apply"}>
                <Button
                    type="button"
                    intent="primary"
                    size="md"
                    className="mt-4  px-6 py-2"
                >
                    Start Your Application

                </Button>
            </Link>
        </div>
    );
};

export default TopBanner;